import { render } from "./tree.vue?vue&type=template&id=18e24004&scoped=true"
import script from "./tree.vue?vue&type=script&lang=js"
export * from "./tree.vue?vue&type=script&lang=js"

import "./tree.vue?vue&type=style&index=0&id=18e24004&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18e24004"]])

export default __exports__